<template lang="pug">
  nav.navbar.is-light(role='navigation' aria-label='main navigation')
    .navbar-brand
      a.navbar-item(to="/")
        img#logoBrand(src='../../assets/ducter_color.png')
      a#navBurger.navbar-burger.burger(role='button' aria-label='menu' aria-expanded='false' data-target='navbarMenu' @click="displayBurger")
        span(aria-hidden='true')
        span(aria-hidden='true')
        span(aria-hidden='true')
    #navbarMenu.navbar-menu
      .navbar-start
      .navbar-end
        .navbar-item
          .buttons
            a.button.is-primary {{ userLogin.nombre }}
            a.button.is-primary(@click="salirSistema")
              | Salir &nbsp
              i.fas.fa-door-open
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import facturasServices from '../../services/facturas/facturas'
export default {
  name: 'NavBarGrupos',
  data () {
    return {
      dateTime: '',
      refresh: null,
    }
  },
  methods: {
    obtenerUser() {
      console.log('Obtener User')
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      } else {
        if (this.userLogin.cargo === '888') {
          //this.iniciarIntervalo()
        }
      }
    },
    displayBurger () {
      let burger = document.getElementById('navBurger')
      let nav = document.getElementById(burger.dataset.target)
      burger.classList.toggle('is-active')
      nav.classList.toggle('is-active')
    },
    salirSistema () {
      this.userSeguridad = {}
      sessionStorage.clear()
      this.$store.commit('setlogin', false)
      this.$store.commit('usuarioLogueado', {})
      this.$router.push('/')
    },
    iniciarIntervalo() {
      console.log('Iniciar Intervlo')
      this.dateTime = moment().format('YYYY-MM-DD HH:mm:ss')
      this.refresh = setInterval(() => {
        this.checktime()
      }, 1000)
    },
    detenerIntervalo() {
      clearInterval(this.refresh)
      this.refresh = null
    },
    checktime () {
      let min = moment().format('mm:ss')
      let minStr = min.substr(1,4)
      if (minStr === '5:00' || minStr === '0:00') {
        console.log('Entró')
        this.checkNewDocs()
      }
    },
    checkNewDocs () {
      facturasServices.checkFacturasNuevasIRGE()
        .then((data) => {
          console.log(data)
          let embProp = data[0].embProp
          console.log(`embProp: ${data[0].embProp}`)

          facturasServices.checkFacturasNuevas()
            .then((dataTPA)=> {
              console.log(dataTPA)
              let factHechas = dataTPA[0].factHechas
              console.log(`factHechas: ${dataTPA[0].factHechas}`)

              if (embProp == factHechas) {
                console.log('Iguales')
              } else {
                let dif = embProp - factHechas
                let text = ''

                if (dif > 1) {
                  text = `Se han registrado ${dif} nuevos embarques.`
                } else {
                  text = `Se registró un nuevo embarque.`
                }

                let toast = this.$toasted.show(text, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : null,
                  iconPack: 'fontawesome',
                  icon: 'clipboard-list',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })

                facturasServices.enviarMailPropangol(dif)
                  .then((resp) => {
                    console.log(resp)
                  })
                  .catch((e)=> console.log(e))
              }
            })
            .catch((e2=> console.log(e2)))
          
        })
        .catch((e) => console.log(e))
    }
  },
  created() {
    this.obtenerUser()
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  },
  beforeDestroy() {
    this.detenerIntervalo()
  }
}
</script>

<style lang="css">
  #logoBrand {
    max-width: 150px;
  }

  .navbar-item img {
    max-height: 100%;
  }

  .navbar.is-light {
    height: 80px;
  }

</style>




// WEBPACK FOOTER //
// src/components/layout/NavBarGrupos.vue